/**
 * El índice de guías, en el orden en que se ofrecen.
 *
 * El orden es el de un colaborador que entra por primera vez: primero
 * entender el panel, después la pantalla donde va a trabajar. Añadir una
 * guía es añadir su archivo en `flows/` y su línea aquí.
 */

import type { TourFlow } from './types';
import { c42Orientacion } from './flows/c42-orientacion';
import { c08TicketsDeSoporte } from './flows/c08-tickets-de-soporte';
import { c44Documentacion } from './flows/c44-documentacion';
import { c12Companias } from './flows/c12-companias';
import { c13Clientes } from './flows/c13-clientes';
import { f03Reembolsos } from './flows/f03-reembolsos';
import { c24bDevolucionesDeSaldo } from './flows/c24b-devoluciones-de-saldo';
import { c19Pagos } from './flows/c19-pagos';
import { c21Liquidaciones } from './flows/c21-liquidaciones';
import { c23CuentasBancarias } from './flows/c23-cuentas-bancarias';
import { c02MonitoreoServidor } from './flows/c02-monitoreo-servidor';
import { c03Monedas } from './flows/c03-monedas';
import { c04Idiomas } from './flows/c04-idiomas';
import { c05VersionesDeLaApp } from './flows/c05-versiones-de-la-app';
import { c06Parametros } from './flows/c06-parametros';
import { c07MonitoreoOperativo } from './flows/c07-monitoreo-operativo';
import { c09Solicitudes } from './flows/c09-solicitudes';
import { c09bComerciosRecomendados } from './flows/c09b-comercios-recomendados';
import { c10SolicitudesDeAsesores } from './flows/c10-solicitudes-de-asesores';
import { c11Colaboradores } from './flows/c11-colaboradores';
import { c14Organizaciones } from './flows/c14-organizaciones';
import { c15Creadores } from './flows/c15-creadores';
import { c17AjustesDelPais } from './flows/c17-ajustes-del-pais';
import { c20IngresosPorCompania } from './flows/c20-ingresos-por-compania';
import { c22PagosProgramados } from './flows/c22-pagos-programados';
import { c25IngresosPorCreador } from './flows/c25-ingresos-por-creador';
import { c27PagosACreadores } from './flows/c27-pagos-a-creadores';
import { c28PagosAAsesores } from './flows/c28-pagos-a-asesores';
import { c29Suscripciones } from './flows/c29-suscripciones';
import { c31Campanas } from './flows/c31-campanas';
import { c32CreditosPromocionales } from './flows/c32-creditos-promocionales';
import { c33Publicidad } from './flows/c33-publicidad';
import { c33bAvisos } from './flows/c33b-avisos';
import { c17cImpuestos } from './flows/c17c-impuestos';
import { c17dTarifasDeServicio } from './flows/c17d-tarifas-de-servicio';
import { c18PanelFinanciero } from './flows/c18-panel-financiero';
import { c24Billeteras } from './flows/c24-billeteras';
import { c30ReportesFinancieros } from './flows/c30-reportes-financieros';
import { c34Estadisticas } from './flows/c34-estadisticas';
import { c34bPuntosYCashback } from './flows/c34b-puntos-y-cashback';
import { c34cFlujoDePuntos } from './flows/c34c-flujo-de-puntos';
import { c30bMisReportes } from './flows/c30b-mis-reportes';
import { c35MisCompanias } from './flows/c35-mis-companias';
import { c36MisComisiones } from './flows/c36-mis-comisiones';
import { c37MisPagos } from './flows/c37-mis-pagos';
import { c38AsesoresComerciales } from './flows/c38-asesores-comerciales';
import { c39AgentesDeSoporte } from './flows/c39-agentes-de-soporte';
import { c40CompaniasSoporte } from './flows/c40-companias-soporte';
import { c41InformesDeSoporte } from './flows/c41-informes-de-soporte';
import { c45ReferidosEntreClientes } from './flows/c45-referidos-entre-clientes';

export const FLOWS: readonly TourFlow[] = [
  c42Orientacion,
  // Va antes que las operativas: enseña dónde está escrito todo lo demás.
  c44Documentacion,
  c08TicketsDeSoporte,
  c12Companias,
  c13Clientes,
  f03Reembolsos,
  c19Pagos,
  c21Liquidaciones,
  c23CuentasBancarias,
  c02MonitoreoServidor,
  c03Monedas,
  c04Idiomas,
  c05VersionesDeLaApp,
  c06Parametros,
  c07MonitoreoOperativo,
  c09Solicitudes,
  c09bComerciosRecomendados,
  c10SolicitudesDeAsesores,
  c11Colaboradores,
  c14Organizaciones,
  c15Creadores,
  c17AjustesDelPais,
  c20IngresosPorCompania,
  c22PagosProgramados,
  c25IngresosPorCreador,
  c27PagosACreadores,
  c28PagosAAsesores,
  c29Suscripciones,
  c31Campanas,
  c32CreditosPromocionales,
  c33Publicidad,
  c33bAvisos,
  c17cImpuestos,
  c17dTarifasDeServicio,
  c18PanelFinanciero,
  c24Billeteras,
  c24bDevolucionesDeSaldo,
  c30ReportesFinancieros,
  c34Estadisticas,
  c34bPuntosYCashback,
  c34cFlujoDePuntos,
  c30bMisReportes,
  c35MisCompanias,
  c36MisComisiones,
  c37MisPagos,
  c38AsesoresComerciales,
  c39AgentesDeSoporte,
  c40CompaniasSoporte,
  c41InformesDeSoporte,
  c45ReferidosEntreClientes,
];

export function findFlow(id: string): TourFlow | undefined {
  return FLOWS.find((flow) => flow.id === id);
}
